<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="شكر-وتقدير">
<h1><strong><span dir="rtl">مقدمة الكاتب</span></strong></h1>
<p><span dir="rtl">فقالت الحياة: وفي النهاية، ماذا ستعتمد قانوناً عاماً ليضبط حياة البشر يا ذا المجد؟</span></p>
<p><span dir="rtl">فأجاب صاحب المجد: أَيَصِحُّ أن أكون غير عادل في هذه؟</span></p>
<p><span dir="rtl">فردَّت الحياة : كيف هذا وأنت مَن أوجد العدل وحفظهُ في كافة أركانها؟</span></p>
<p><span dir="rtl">فرَدَّ عليها: بل سيكون منتهى العدل. لهذا يكون قانونها متغيراً وبحسب إيمان المفكر، وما يعتقد في باطنه وبإرادته يختار كل أمرٍ لنفسه فيقرر، ويخلق هذا له واقع حياته وكل ما يختبر. فالذي يعيش حاضرهُ مغامراً شجاعاً ويحسن الظن يبني.. يتوسع ويثمر، أما مَن يبقى أسير الماضي سجين الخوف ومسيءَ الظن؛ فإنه يتراجع.. ينحدر ويضمر.</span> <span dir="rtl">وهذه الحقيقة حقٌ لكل إنسان إذا تأمَّل عمق نفسه وسأل وثابر ليعرف كيف إليها يَحفر.</span></p>
<p><span dir="rtl">فقالت الحياة: لا ريب بذلك؛ فأنت كُلِّيُّ الحضور والعلم والمعرفة.. بهذا القانون يكون البشري هو اللاعب والحَكَم. والحياة تكون له المرشد والعِلم.</span></p>
<p><span dir="rtl">فقال ذو المجد: فليكن هكذا. فكان كذلك. فجُسدَت الكلمة لثمرة.</span> <span dir="rtl">فرأى أن ذلك حسن</span>. <span dir="rtl"></span></p>
<p><span dir="rtl">عندها فقط بدأنا نحن.</span></p>
<p><span dir="rtl">فرأيتُ وكأن الحقيقة صوِّرَتْ لي على هيئة غصنٍ عالٍ قائم وهو لين ويحمل ثماراً كثيرةً.</span> <span dir="rtl">فجاءَه شخصٌ وأَمَاله يميناً حيث يقف وقطف الثمرة القريبة ومضى. بعدها جاء آخر فحناه يساراً باتجاهه وقطف ثمرة أخرى وذهب، وتلاهُ آخرون فعلوا الشيء ذاتهُ.</span> <span dir="rtl">كلٌّ أَمَالَ الغصن لزاويته وأخذ نصيبه من هذا الغصن وابتعد.</span></p>
<p><span dir="rtl">وسألتُ نفسي: هل يعتقد أيٌ منهم أنه هو فقط من قطف ثمرة وأن قطافها لا بدَّ أن يكون من حيث كان يقف ويرى؟</span>! <span dir="rtl">فتأملت الموقف حتى أدركتُ عمق معناه وحفظتهُ في نفسي</span>.</p>
<p><span dir="rtl">مَن كان لهُ عقل مفكر فليدرك</span>.</p>
<p><span dir="rtl">ليـــث حجـازيـن</span></p>
<p><span dir="rtl"><br/>
</span></p>
<p><span dir="rtl">أَتَعْـــلَمُ؟</span></p><br/>
<p><span dir="rtl">عَلَيْـكَ فِعْلُهَا مِنْ أَجْـلِ نَفْسِـكَ!</span></p>
<p><span dir="rtl">لَيْسَ من أَجْلِ أَحَدٍ، بَلْ مِنْ أَجْلِ نَفْسِـكَ!</span></p><br/>
<p style="text-align: center;"><span dir="rtl">لِــذَا..</span></p>
<p style="text-align: center;"><strong><span dir="rtl"><span style="text-decoration:underline;">اِنْهَــــضْ!</span></span></strong></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?5162a7a8